// Locally bundled classic scripts preserve support for opening index.html via file://.
export const THREE = window.THREE;
export const qrcode = window.qrcode;
